import { useState, useEffect, React, useReducer } from 'react';
import { initialstate, myreducer, fetchbygetmethod, fetchbyputmethod, fetchbypostmethod } from '../../Commonfiles/Myreducer';
import Spinner from '../../Commonfiles/spinner';
import Nodatafound from '../../Commonfiles/nodatafound';
import { Gotohome } from '../../Commonfiles/checkfortoken';

function Adminaddeditcountry() { 
    const [data, setdata] = useReducer(myreducer, initialstate);
    const [mydata, setmydata] = useReducer(myreducer, initialstate);

    async function loaddata() {
        fetchbygetmethod(setdata, 'Adminaddeditcountry', {});
        console.log(setdata);
    }

	async function Insertdata() {
		var countryname = document.getElementById('insertcountryname');
		var isdcode = document.getElementById('insertisdcode');
		var status = document.getElementById('selectstatus');
	
		var jsonobj = { CountryName: countryname.value, ISDCode: isdcode.value, Status: status.value };
		
		try {
			await fetchbypostmethod(setmydata, 'Admininsertcountry', jsonobj);
			alert("Country Registered Successfully");
			window.location.reload(); // Reloads the page after successful registration
		} catch (error) {
			console.error("Error during registration:", error);
		}
	}
	
	

    useEffect(() => {
        loaddata();
    }, []);

    return (
        <div className="content-page">
            <div className="content">
                <div className="">
                    <div className="page-header-title">
                        <h4 className="page-title">Country</h4>
                    </div>
                </div>

                <div className="page-content-wrapper ">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="panel panel-primary">
                                    <div className="panel-body">
                                        <h4 className="m-t-0 m-b-30">Add Country</h4>
                                        <hr width="100%" />
                                        <div className="row">
                                            <div className="col-sm-6 col-xs-12">
                                                <div className="m-t-20">
                                                    <form>
                                                        <div className="form-group">
                                                            <label>Country Name</label>
                                                            <div>
                                                                <input type="text" className="form-control" required id='insertcountryname' />
                                                            </div>
                                                        </div>

                                                        <div className="form-group">
                                                            <label>Is Block</label>
                                                            <select className="form-control" id='selectstatus'>
                                                                <option value="Y">UnBlock</option>
                                                                <option value="N">Block</option>
                                                            </select>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                            <div className="col-sm-6 col-xs-12">
                                                <div className="m-t-20">
                                                    <form>
                                                        <div className="form-group">
                                                            <label>ISD Code</label>
                                                            <div>
                                                                <input type="text" className="form-control" required id='insertisdcode' />
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <div>
                                                    <button
                                                        type="submit"
                                                        className="btn btn-primary waves-effect waves-light"
                                                        style={{ marginLeft: 300, marginTop: 5 }}
                                                        onClick={Insertdata} // Pass the function reference without calling it
                                                    >
                                                        Add
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="panel panel-primary">
                                            <div className="panel-body">
                                                <h4 className="m-b-30 m-t-0">Countries Details</h4>
                                                <table id="datatable-buttons" className="table table-striped table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th>Sr No.</th>
                                                            <th>Country Name</th>
                                                            <th>ISD Code</th>
                                                            <th>Status</th>
                                                            <th>Edit</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {data.myloading ? (
                                                            <Spinner />
                                                        ) : data.myerror ? (
                                                            <Nodatafound />
                                                        ) : data.mypost.length > 0 ? (
                                                            data.mypost.map((row, index) => (
                                                                <tr key={index+1}>
                                                                    <td>{row.Countryid}</td>
                                                                    <td>{row.CountryName}</td>
                                                                    <td>{row.ISDCode}</td>
                                                                    <td>{row.Status}</td>
                                                                    <td><input type="button" value="Edit" /></td>
                                                                </tr>
                                                            ))
                                                        ) : null}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Gotohome mydata={data} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Adminaddeditcountry;
